import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from 'react-redux';
import { modifieJoueurParOrder, trierPartie } from "../redux/partieSlice";

const TabPlayer = () => {
  const [donnees, setDonnees] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const partie = useSelector((state) => state.partie);

  // Synchronise les données locales avec Redux
  useEffect(() => {
    const nouvellesDonnees = Array.isArray(partie)
      ? partie.map((ligne) => ({
        order: ligne.order,
        name: ligne.name,
        role: ligne.name,
        Joueur: ligne.Joueur || ""
      }))
      : [];
    setDonnees(nouvellesDonnees);
  }, [partie]);

  // Reset
  const ResetGame = () => {
    navigate("/", { replace: true });
  };

  const DeletePlayer = () => {
    const updatedData = donnees.map((item) => ({ ...item, Joueur: "" }));
    setDonnees(updatedData);
    
    // Mettre à jour Redux pour chaque ligne
    updatedData.forEach((item) => {
      dispatch(modifieJoueurParOrder({ order: item.order, joueur: "" }));
    });
  }


  // Édition cellule
  const onCellEditComplete = (e) => {
    let { rowData, newValue, field, originalEvent: event } = e;

    if (newValue.trim().length > 0 || field === "Joueur") {
      const updatedData = donnees.map((item) =>
        item.order === rowData.order ? { ...item, [field]: newValue } : item
      );
      setDonnees(updatedData);

      if (field === "Joueur") {
        dispatch(modifieJoueurParOrder({ order: rowData.order, joueur: newValue }));
      }
    } else {
      event.preventDefault();
    }
  };



  const handleEdit = (id, field, newValue) => {
    // Mise à jour des données
    if (newValue.trim().length > 0 || field === "Joueur") {
      const updatedData = donnees.map((item) =>
        item.order === id ? { ...item, [field]: newValue } : item
      );
      setDonnees(updatedData);

      if (field === "Joueur") {
        dispatch(modifieJoueurParOrder({ order: id, joueur: newValue }));
      }
    };
  };

  return (
    <div>
      <div className='TabButtonGroup'>
        <Button className="TabButton" outlined onClick={() => dispatch(trierPartie())} icon="pi pi-sort-amount-down" rounded />
        <Button className="TabButton" onClick={ResetGame} outlined icon="pi pi-refresh" rounded />
        <Button className="TabButton" onClick={DeletePlayer} outlined icon="pi pi-trash" rounded />
      </div>

      <table>
        <thead>
          <tr style={{ backgroundColor: "white" }}>
            <th>Role</th>
            <th>Joueur</th>
          </tr>
        </thead>
        <tbody>
          {donnees.map((ligne) => (
            <tr key={ligne.order}>
              <td>
                <input
                  type="text"
                  value={ligne.name}
                  onChange={(e) => handleEdit(ligne.order, 'Role', e.target.value)}
                />
              </td>
              <td>
                <input
                  type="text"
                  value={ligne.Joueur}
                  onChange={(e) => handleEdit(ligne.order, 'Joueur', e.target.value)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

};

export default TabPlayer;
